import React from 'react';

import HeaderFreecode from 'components/HeaderFreecode/HeaderFreecode';
import { FreecodePageBackground, FreecodePageContentContainer, GlobalStyle } from './styles';

export default function FreecodePage({ children, contest, headerLinks = [] }) {
  return (
    <FreecodePageBackground>
      <GlobalStyle />
      <HeaderFreecode contest={contest} headerLinks={headerLinks} />
      <FreecodePageContentContainer>{children}</FreecodePageContentContainer>
    </FreecodePageBackground>
  );
}
